<template>
  <el-dropdown
    class="dots-menu"
    trigger="click"
    :placement="placement"
    :disabled="items.length === 0"
    @command="onCommand"
  >
    <span class="dots-menu__trigger">
      <Icon name="dots-horizontal" />
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="item in items" :key="item.command" :command="item.command" :disabled="item.disabled">
        {{ item.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'

import { DotsMenuItem } from './types'

export default defineComponent({
  name: 'DotsMenu',
  components: {
    Icon
  },
  props: {
    items: {
      type: Array as PropType<DotsMenuItem[]>,
      required: true
    },
    placement: {
      type: String,
      default: 'bottom-start'
    }
  },
  setup(props, context) {
    function onCommand(command: string) {
      const target = props.items.find(item => item.command === command)
      if (target?.disabled) {
        return
      }
      context.emit('command', command)
    }

    return {
      onCommand
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.dots-menu {
  display: inline-flex;
}

.dots-menu__trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: $spacing-unit * 4;
  height: $spacing-unit * 4;
  cursor: pointer;
  border-radius: $round;

  &:hover {
    background-color: $background-color;
  }
}
</style>
